import { useQuery } from '@tanstack/react-query';

import { Button } from '../../components/ui/Button.jsx';
import { Modal } from '../../components/ui/Modal.jsx';
import { Spinner } from '../../components/ui/Spinner.jsx';
import { useTranslation } from '../../i18n/useTranslation.js';
import { productionApi } from '../../services/productionApi.js';

function TreeRows({ nodes }) {
  return nodes.flatMap((n) => [
    <tr key={`${n.componentProductId}-${n.level}-${n.sku}`}>
      <td>
        <span style={{ paddingLeft: `${(n.level - 1) * 18}px` }}>
          <span className="muted">{n.isAssembly ? '▸' : '·'}</span> <span className="mono">{n.sku}</span> {n.name}
        </span>
      </td>
      <td className="num mono">{Number(n.quantity).toFixed(4)}</td>
    </tr>,
    ...(n.children ? [<TreeRows key={`c-${n.componentProductId}-${n.level}`} nodes={n.children} />] : []),
  ]);
}

export function BomExplodeModal({ bomId, onClose }) {
  const { t } = useTranslation();
  const detail = useQuery({ queryKey: ['production', 'bom-explode', bomId], queryFn: () => productionApi.explodeBom(bomId).then((r) => r.items), enabled: Boolean(bomId) });
  const data = detail.data;

  return (
    <Modal open={Boolean(bomId)} onClose={onClose}
      title={data ? `${t('production.boms.explodeTitle')} · ${data.bom.code}` : t('production.boms.explode')}
      footer={<Button variant="ghost" onClick={onClose}>{t('common.close')}</Button>}>
      {detail.isLoading ? <Spinner /> : data && (
        <div className="form-stack">
          <p className="muted text-sm">{data.bom.productSku} · {data.bom.productName} · {t('production.boms.outputQuantity')}: {data.bom.outputQuantity}</p>

          <div className="settings-divider">{t('production.boms.structure')}</div>
          <div className="table-wrap">
            <table className="table">
              <thead><tr><th>{t('production.boms.component')}</th><th className="num">{t('production.boms.quantity')}</th></tr></thead>
              <tbody><TreeRows nodes={data.tree || []} /></tbody>
            </table>
          </div>

          <div className="settings-divider">{t('production.boms.requirements')}</div>
          <div className="table-wrap">
            <table className="table">
              <thead><tr><th>{t('production.boms.material')}</th><th className="num">{t('production.boms.totalQty')}</th></tr></thead>
              <tbody>
                {(data.requirements || []).map((r) => (
                  <tr key={r.sku}><td><span className="mono">{r.sku}</span> {r.name}</td><td className="num mono">{Number(r.quantity).toFixed(4)}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </Modal>
  );
}
